import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'assessment-generation-confirm-dialog',
  templateUrl: 'assessment-generation-confirm-dialog.component.html',
  styleUrls: ['assessment-generation-confirm-dialog.component.scss'],
})
export class AssessmentGenerationConfirmationDialogComponent {
  userType: string = "all";

  constructor(
    public dialogRef: MatDialogRef<AssessmentGenerationConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      programsMode: boolean,
      defaultUserType: string,
      hasExportButton: boolean
    }) {
    this.userType = data.defaultUserType;
  }

  onUserTypeChange(event: any) {
    this.userType = event.value;
  }

  confirm() {
    this.dialogRef.close({ userType: this.userType });
  }

  openHelp() {
    window.open('https://intercom.help/wonda-pro/en/articles/12097485-iterating-on-an-assessment');
  }
}
